import { login, logout, getInfo,lairPasslogin } from '@/api/user'
import { getToken, setToken, removeToken } from '@/util/auth'

const initState = {
  token: getToken(),
  name: '',
  roles: [],
  userInfo: {},
  loginVisible: false,
}

const user = {
  namespaced: true,
  state: initState,
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USER: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_LOGINVISIBLE: (state, isVisible = false) => {
      state.loginVisible = isVisible
    },
  },
  actions: {
    // 手机验证码登录 loginType='2'
    phoneLogin({ dispatch, commit }, userInfo) {
      const { phone, code, checkLoginStatus } = userInfo
      return new Promise((resolve, reject) => {
        login({
          mobile: phone.toString(),
          code: code,
          loginType: '2',
          expired7: Number(checkLoginStatus),
        })
          .then((response) => {
            // 先用本次登录的手机号兜底顶栏展示：name 原本只由 getInfo 回填，
            // getInfo 失败/超时会让顶栏误显示「立即登录」。getInfo 成功后会覆盖成服务端返回的号码；
            // 若 getInfo 返回 401，拦截器会 resetToken 把 name 一并清掉。
            commit('SET_NAME', phone.toString())
            dispatch('login', response).then(resolve)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 此方法弃用，安全性低
    // phoneLogin3({ dispatch }, userInfo) {
    //   const { phone } = userInfo
    //   return new Promise((resolve, reject) => {
    //     login({
    //       mobile: phone.toString(),
    //       loginType: '3',
    //     })
    //       .then((response) => {
    //         dispatch('login', response).then(resolve)
    //       })
    //       .catch((error) => {
    //         reject(error)
    //       })
    //   })
    // },
    //验签免认证登录
    phoneLogin4({ dispatch }, userInfo) {
      const { phone, outerOrderNo, apiId, requestTime, sign } = userInfo
      return new Promise((resolve, reject) => {
        lairPasslogin({
          mobile: phone.toString(),
          loginType: '4',
          outerOrderNo: outerOrderNo,
          apiId: apiId,
          requestTime: requestTime,
          sign: sign,
        })
          .then((response) => {
            dispatch('login', response).then(resolve)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 用户名密码登录 loginType='1'，xstr加密后的密码
    userLogin({ dispatch }, userInfo) {
      const { username, password, checkLoginStatus } = userInfo
      return new Promise((resolve, reject) => {
        login({
          username: username,
          xstr: password,
          loginType: '1',
          expired7: Number(checkLoginStatus),
        })
          .then((response) => {
            dispatch('login', response).then(resolve)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    login({ commit, dispatch }, response) {
      const { data } = response
      const { expiredTime, currentTime, token } = data
      commit('SET_TOKEN', token)
      commit('SET_LOGINVISIBLE', false)
      setToken(token, (expiredTime - currentTime) / 1e3)
      return dispatch('getInfo')
    },
    // 获取用户信息
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((response) => {
            const { data } = response

            if (!data) {
              reject('Verification failed, please Login again.')
            }

            const { roles, mobile } = data
            commit('SET_USER', data)
            commit('SET_ROLES', roles)
            commit('SET_NAME', mobile)
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 退出登录
    logout({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            commit('SET_USER', '')
            commit('SET_NAME', '')
            dispatch('resetToken').then(() => {
              resolve()
            })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // remove token
    resetToken({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_NAME', '')
        removeToken()
        resolve()
      })
    },
  },
}
export default user
